import React, { useMemo } from 'react'
import { Grid, Checkbox } from '@material-ui/core'
import { useGetAiModels } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import OpalPresentationTable from '../../../../../components/organisms/DenaliAnalysis/tables/presentation'

const columns = [
  { accessorKey: 'providerName', header: 'Provider', id: 'providerName', size: 180, minSize: 120 },
  { accessorKey: 'modelName', header: 'Model', id: 'modelName', size: 220, minSize: 150 },
  { accessorKey: 'tasks', header: 'Tasks', id: 'tasks', size: 100, minSize: 80 },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    id: 'enabled',
    size: 100,
    minSize: 100,
    enableResizing: false,
    align: 'center',
    cell: (info) => {
      const enabled = info.getValue()
      return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Checkbox
            checked={Boolean(enabled)}
            disabled
            size='small'
          />
        </div>
      )
    }
  }
]

function ModelsList () {
  const { data, isLoading, error } = useGetAiModels()

  const tableData = useMemo(() => {
    return (data?.models || []).map(rt => ({
      providerName: rt.provider?.name || 'Unknown',
      modelName: rt.name,
      tasks: rt.tasks?.length || 0,
      enabled: rt.enabled
    }))
  }, [data])

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div>Error loading models: {error.message || 'Unknown error'}</div>
        </Grid>
      </Grid>
    )
  }

  if (!tableData || tableData.length === 0) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div>No models available</div>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <OpalPresentationTable
          columns={columns}
          data={tableData}
          defaultSort={[]}
        />
      </Grid>
    </Grid>
  )
}

export default ModelsList
